import { type ReactNode, createContext, useContext } from "react";
import { usePracticeTests } from "../hooks/usePracticeTests";

type PracticeTestsContextValue = ReturnType<typeof usePracticeTests>;

const PracticeTestsContext = createContext<PracticeTestsContextValue | null>(
	null,
);

export const PracticeTestsContextProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const value = usePracticeTests();
	return (
		<PracticeTestsContext.Provider value={value}>
			{children}
		</PracticeTestsContext.Provider>
	);
};

export const usePracticeTestsContext = () => {
	const context = useContext(PracticeTestsContext);
	if (!context) {
		throw new Error(
			"usePracticeTestsContext must be used within a PracticeTestsContextProvider",
		);
	}
	return context;
};
